import { VDBText } from "@components/atoms";
import CollapsibleView from "@components/molecules/CollapsibleView";
import { useTranslation } from "react-i18next";
import styled from "styled-components/native";
import { MatchSupplierCommentViewProps } from "./types";
import { Platform } from "react-native";
import { css } from "styled-components/native";
import { matchPairConatinerWidth } from "@scenes/findMatch/utils";
import { getProductProperty } from "../ProductDetailList/utils";
import { PriceModes } from "@components/molecules/PriceModeCard/types";

const MatchSupplierCommentView = ({
  itemDetail,
  otherDetail,
  currentIndex,
  priceMode,
}: MatchSupplierCommentViewProps) => {
  const { t } = useTranslation();
  let supplierComment = getProductProperty(
    itemDetail?.supplier_specific_comment,
    ""
  );
  let otherSupplierComment = getProductProperty(
    otherDetail?.[currentIndex]?.supplier_specific_comment,
    ""
  );
  if (priceMode === PriceModes.WHITE) {
    const deliveryStr = itemDetail?.estimated_delivery
      ? ` | ${t(
          "productDetailPage.estimatedDelivery.text",
          "Estimated Delivery:"
        )} ${itemDetail.estimated_delivery}`
      : "";
    supplierComment += deliveryStr;
    const otherDeliveryStr = otherDetail?.[currentIndex]?.estimated_delivery
      ? ` | ${t(
          "productDetailPage.estimatedDelivery.text",
          "Estimated Delivery:"
        )} ${otherDetail?.[currentIndex]?.estimated_delivery}`
      : "";
    otherSupplierComment += otherDeliveryStr;
  }
  return (
    <PriceDetailContainer>
      <FlexMainView>
        <MainContainerView testID="findMatch.supplierComment.primary">
          <LeftLabelContainer keyMargin={20}>
            <CollapsibleView
              initExpanded={true}
              title={t("productDetailPage.supplierComments.text")}
            >
              <Divider />
              <Container>
                <VDBText>{supplierComment}</VDBText>
              </Container>
            </CollapsibleView>
          </LeftLabelContainer>
        </MainContainerView>
        <GapView />
        <MainContainerView testID="findMatch.supplierComment.secondary">
          <LeftLabelContainer keyMargin={20}>
            <CollapsibleView
              initExpanded={true}
              title={t("productDetailPage.supplierComments.text")}
            >
              <Divider />
              <Container>
                <VDBText>{otherSupplierComment}</VDBText>
              </Container>
            </CollapsibleView>
          </LeftLabelContainer>
        </MainContainerView>
      </FlexMainView>
    </PriceDetailContainer>
  );
};

const Container = styled.View`
  padding: 12px;
`;

const PriceDetailContainer = styled.View`
  flex-direction: column;
`;

const MainContainerView = styled.View<any>`
  flex-direction: column;
  justify-content: space-between;
  flex: 1;
  ${({ theme }) => matchPairConatinerWidth(theme)}
`;

const FlexMainView = styled.View<any>`
  flex-direction: row;
  justify-content: space-between;
`;

const LeftLabelContainer = styled.View<any>`
  margin: ${({ keyMargin }) => `10px ${keyMargin}px`};
`;

const Divider = styled.View`
  height: 1px;
  flex-direction: row;
  background-color: ${({ theme }) => theme["core-03"]};
  width: 100%;
  maxwidth: 100%;
`;

const GapView = styled.View`
  ${({ theme }) =>
    Platform.OS === "web" &&
    !theme.isMobile &&
    css`
      width: 30px;
    `}
`;

export default MatchSupplierCommentView;
